<!--  Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved. -->

<template>
	<div class="app app__border v-theme--customTheme">
		<div class="app__innerContainer">
			<router-view name="header" />
			<router-view />
		</div>
		<notifications />
	</div>
</template>

<script>
import Notifications from './components/Notifications.vue';

export default {
	name: 'app-comp',
	components: {
		Notifications,
	},
};
</script>

<style lang="scss">
body {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	font-family: $font;
	margin: 0;
}

html {
	overflow: auto !important;
}

.app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	&__border {
		background: $blue !important;
		min-height: 100vh;
		display: flex;
	}

	&__innerContainer {
		margin: 0 8px 8px 8px;
		background: white;
		display: flex;
		flex-direction: column;
		overflow: auto;
		flex: 1;
	}
}
</style>
